/* payments will list all the payments
  *
  *
  *
  * */
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {transactionsVerificationList_template} from "../components/templates/transactionsVerificationList_template";
import {header} from "./header";


declare var ko: any;
declare var page: any;

export class transactions_verification extends vnModule_knockoutJS {

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected listTemplate: transactionsVerificationList_template;

    protected getModuleName() {
        return "transactions_verification";
    }

    buildContent(): Array<Element> {
        // create the topics list
        this.listTemplate = new transactionsVerificationList_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Transactions Verification Page");

        return [this.listTemplate.build()];
    }

    public fillPage(): void {

        // init calendar
        // ** this need to be done AFTER the element is inserted in the page
        // as it uses query selector to load the calendars
        this.listTemplate.buildDatePickerCalendar();
        this.getFormData();
        this.filterList();

    }

    protected getFormData(){

       // this.listTemplate.activateLoading();

        if( "getFormData" in this.XHRHdls ){
            this.XHRHdls["getFormData"].cancelAndReset();
        }

        let usrReq_url: string =  '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transactions/verification/formData/';
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdls["getFormData"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getFormData"].onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdls["getFormData"].execute();
    }

    protected onGetFormDataReturn(req, obj){

        return function() {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                let data = responseParsed.data;
                obj.listTemplate.setContentTypes(data.contentTypes);
                obj.listTemplate.setPaymentCategoryFilterItems(data.systemPaymentCategories);
                obj.listTemplate.setZeroColumnFilterItems(data.zeroColumnOptions);
            })
        }
    }

    protected filterList() {

        // LOADING : starts
        this.listTemplate.activateLoading();

        if( "filterList" in this.XHRHdls ){
            this.XHRHdls["filterList"].cancelAndReset();
        }

        let subViewModel = {
            list: {orderBy: this.viewModel.list.orderBy, orderByDirection: this.viewModel.list.orderByDirection},
            pagination: this.viewModel.list.pagination,
            date: this.viewModel.list.dateRangeFilter,
            filterUser: {
                userId: this.viewModel.list.filterUser.idUser
            },
            filterArticle: {
                idArticle: this.viewModel.list.filterArticle.idArticle
            },
            filterContentTypes: {
                idContentTypes: this.viewModel.list.filterContentType.selectedItems
            },
            filterPaymentCategories: {
                idPaymentCategories: this.viewModel.list.paymentCategoryFilter.selectedItems
            },
            idRole : this.viewModel.list.rolesFilter.selectedOption,
            zeroColumns: this.viewModel.list.zeroColumnsFilter.selectedItems,
            viewDaysSpan: this.viewModel.list.viewDaysSpan,
            ppsRate: this.viewModel.list.ppsRate,
            maxPpsPayout: this.viewModel.list.maxPpsPayout,
            minPayout: this.viewModel.list.minPayout,
            sessionAggregate: this.viewModel.list.sessionAggregate,
            filterKeywords: this.viewModel.list.filterKeywords.filterKeyword
        };

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transactions/verification/list/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["filterList"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        let localCheck = this.XHRHdls["filterList"].requestId;
        let _myThis = this;
        setTimeout(function () {

            if (localCheck == _myThis.XHRHdls["filterList"].requestId) {
                _myThis.XHRHdls["filterList"].onReadyStateFunction = _myThis.onFilterRequestReturn;
                _myThis.XHRHdls["filterList"].execute();
            }
        }, 400);
    }

    protected onFilterRequestReturn(req, obj) {

        return function(){
            obj.manageResponse(req, obj,function () {
                const execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100

                let responseParsed = JSON.parse(req.request.response);
                const {
                    totalPages,
                    count,
                    totalAmount,
                    totalCommission,
                    totalPerformance,
                    totalSessions,
                    totalUsSessions,
                    totalPpsCalc,
                    totalPpsUsCalc,
                    totalPpsAllCalc
                } = responseParsed.data;

                const totals = {
                    totalPages,
                    count,
                    totalAmount,
                    totalCommission,
                    totalPerformance,
                    totalSessions,
                    totalUsSessions,
                    totalPpsCalc,
                    totalPpsUsCalc,
                    totalPpsAllCalc
                };

                obj.updateList(responseParsed.data);
                obj.listTemplate.setResultInfo(totals, execTime);
                obj.listTemplate.deactivateLoading();
            })
        }
    }

    protected paginationOnPageClick() {
        this.filterList();
    }

    protected updateList(responseParsed: any) {

        this.listTemplate.setData(responseParsed.data, responseParsed.companyId);

        // update the paginator
        this.viewModel.list.pagination.itemCount(responseParsed.count);

    }

    protected filterDateOnChange() {
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange() {
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterMultipleSelectorOnChange(){
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected getUsersSuggestion(keyword) {

        let subViewModel = {
            list: {
                keyword: keyword,
                idRole: this.viewModel.list.rolesFilter.selectedOption,
            }
        };
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function(){
            obj.manageResponse(req, obj,function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.listTemplate.validationsList.clearMessages();
                if (responseParsed.data.users) {
                    obj.listTemplate.setUsers(responseParsed.data.users);
                }

                // LOADING : ends
                obj.listTemplate.deactivateLoading();
            })
        }

    }

    protected getArticlesSuggestion(keyword) {

        if( "getArticlesSuggestion" in this.XHRHdls ){
            this.XHRHdls["getArticlesSuggestion"].cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getArticlesSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getArticlesSuggestion"].onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdls["getArticlesSuggestion"].execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function(){
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.articles) {
                    obj.listTemplate.setArticles(responseParsed.data.articles);
                }

                // LOADING : ends
                obj.listTemplate.deactivateLoading();
            })
        }
    }

    protected addTransaction() {
        if (this.getVnAppZone().app.params.idBrand) {
            page('/brand/' + this.getVnAppZone().app.params.idBrand + '/transaction/add');
        }else {
            page('/valnet/transaction/add');
        }
    }

    protected editTransaction(id) {

        if (this.getVnAppZone().app.params.idBrand) {
            page('/brand/' + this.getVnAppZone().app.params.idBrand + '/payment/transaction/edit/' + id);
        }else {
            page('/valnet/payment/transaction/edit/' + id);
        }
    }

    protected deleteTransaction(id) {
        if (this.getVnAppZone().app.params.idBrand) {
            page('/brand/' + this.getVnAppZone().app.params.idBrand + '/payment/transaction/delete/' + id);
        }else {
            page('/valnet/payment/transaction/delete/' + id);
        }
    }

    protected transactionListReorder() {

        this.filterList();
    }

    protected filterSimpleOnChange() {

        this.filterList();
    }

    protected filterSimpleCancel(){

    }

    protected save(idRole, data){

        this.loadingIn(this.listTemplate.builtTemplate);
        let transactionSystem = "VN";

        let vnApp = this.getVnAppZone().app;
        for ( let b of vnApp.loggedUser.user.brands ) {

            if( b.id == this.getVnAppZone().app.params.idBrand){

                transactionSystem = b.shortName;
            }
        }

        let formReq_url: string = '/api/' + transactionSystem + '/transactions/payments/fixes/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = {
            idRole: idRole,
            list: JSON.parse(ko.toJSON(data))
        };

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function() {

                obj.manageResponse(req, obj, function(){

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Changes applied successfully !")

                    obj.fillPage();
                })
                obj.loadingOut(obj.listTemplate.builtTemplate);

            }
        });
        XHRHdl.execute();
    }
}



// WEBPACK FOOTER //
// ./js/modules/transactions_verification.ts